import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"

const UpdateCustomerForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [formData, setFormData] = useState({
        full_name: "",
        contact_number: "",
        responsible_name: "",
        responsible_contact: "",
        public_id: ""
    })
    const {full_name, contact_number, responsible_name, responsible_contact, public_id} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect (() => {
        if (location.state){
            const {customer} = location.state
            setFormData({
                full_name: customer.full_name,
                contact_number: customer.contact_number,
                responsible_name: customer.responsible_name,
                responsible_contact: customer.responsible_contact,
                public_id: customer.public_id
            })
        }

    }, [location])

    

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const customerData = {full_name, contact_number, responsible_name, responsible_contact}
        updateCustomer(public_id, customerData)
    }

    //update customer
    const updateCustomer = async (public_id, customerData) => {
        try {
            setIsLoading(true)
            const response = await Server.put(`/customers/${public_id}`, customerData)
            if(response.status === 200){
                toast.success('Successfully updated')
                navigate('/customers-serverside')
                setIsLoading(false)
            }else{
                setIsLoading(false)
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail);
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header d-flex p-2 bg-info justify-content-center">
                <h3 className="card-title">Update Customer Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                placeholder="Customer Name"
                                name="full_name"
                                type="text"
                                label="Name"
                                value={full_name}
                                onChange={onChange}
                                error={errors.full_name}
                            />
                        </div>

                        <div className="col-md-3">
                        <InputField
                            placeholder="Customer Contact"
                            name="contact_number"
                            type="text"
                            label="Contact"
                            value={contact_number}
                            onChange={onChange}
                            error={errors.contact_number}
                        />
                        </div>

                        <div className="col-md-3">
                        <InputField
                            placeholder="Resonsible Person Name"
                            name="responsible_name"
                            type="text"
                            label="Resonsible Name"
                            value={responsible_name}
                            onChange={onChange}
                            error={errors.responsible_name}
                        />
                        </div>

                        <div className="col-md-3">
                        <InputField
                            placeholder="Resonsible Person Contact"
                            name="responsible_contact"
                            type="text"
                            label="Resonsible Contact"
                            value={responsible_contact}
                            onChange={onChange}
                            error={errors.responsible_contact}
                        />
                        </div>
                    </div>
                    <br/>
                    <input type="submit" className="btn btn-outline-info btn-block " value="Update Customer"/>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default UpdateCustomerForm
